var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.overlayItem,
    _vm.open && _vm.$style.open
  ]},[_c('div',{class:_vm.$style.question,on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v(" "+_vm._s(_vm.question)+" ")]),_c('div',{class:_vm.$style.answer,domProps:{"innerHTML":_vm._s(_vm.answer)}})])}
var staticRenderFns = []

export { render, staticRenderFns }